import moment from 'moment';

export const AgendaDateAsDay = (date) => {
  const m = moment(date, "YYYY-MM-DD");
  return m.isValid() ? m.format("dddd") : null;
}

export const AgendaDateAsShortDate = (date) => {
  const m = moment(date, "YYYY-MM-DD");
  return m.isValid() ? m.format("Do MMM") : null;
}

export const today = () => {
  return moment().format("YYYY-MM-DD");
}



// WEBPACK FOOTER //
// ./src/module/Dates.js